/** @format */

import React, { Component } from 'react';
import Paginations from '../../components/Pagination/PaginationExt';
// const _ = require('underscore');
import { componentDebug } from '../../core/debug';
import TextField from '@material-ui/core/TextField';
import withStyles from '@material-ui/core/styles/withStyles';
import oplAppStyle from '../../assets/themes/OPL/jss/App/OplAppStyle';

class Pager extends Component {
    constructor(props) {
        super(props);

        const current = this.getNumberFromUri(props.views['@id']) ?? 1;

        const goToPage = (
            <TextField
                onChange={this.goToPage}
                onKeyDown={this.handleKeyDown}
                variant={'filled'}
                classes={props.classes.paginatorTextField}
                value={current}
                inputProps={{
                    className: props.classes.paginatorInputStyle,
                }}
                InputProps={{
                    className: props.classes.paginatorLabelStyle,
                }}
            />
        );

        this.state = {
            currentPage: current,
            goToPageButton: goToPage,
        };
    }
    buttonHit = (url) => {
        componentDebug(window._ROOT_DATA_PROVIDER + url);
        const { callback } = this.props;

        if (callback) {
            callback(url);
        } else {
            componentDebug('No callback function');
        }
    };

    shouldComponentUpdate(nextProps, nextState, nextContext) {
        const page = this.getNumberFromUri(this.props.views['@id']);
        const nextPage = this.getNumberFromUri(nextProps.views['@id']);
        if (page !== null && nextPage !== null && (nextPage > page || nextPage < page)) {
            const refreshedBtn = this.createGoToTextField(nextPage);
            this.setState((prevState) => ({
                ...prevState,
                goToPageButton: refreshedBtn,
            }));
        }

        componentDebug(nextProps);
        return true;
    }

    getNumberFromUri = (uri) => {
        const reg = /[?&]{1,}page=(\d+)/gi;
        const nr = reg.exec(uri);
        if (nr && nr[1]) {
            return nr[1];
        }
        return null;
    };

    getPageUrl = (url, page) => {
        if (page) {
            return url + page;
        }
        return null;
    };

    createPages = () => {
        const { views } = this.props;

        // let reg = /page=(\d+)/gi;

        let last = 1;
        let prev = null;
        const current = this.getNumberFromUri(views['@id']) ?? 1;
        let next = null;
        const url = views['@id'].replace(/\?page=\d+/gi, '?page=').replace(/&page=\d+/gi, '&page=');

        if (views['hydra:last']) {
            last = this.getNumberFromUri(views['hydra:last']);
        }
        if (views['hydra:next']) {
            next = this.getNumberFromUri(views['hydra:next']);
        }
        if (views['hydra:previous']) {
            prev = this.getNumberFromUri(views['hydra:previous']);
        }

        return {
            pages: [
                { text: !isNaN(parseInt(prev)) ? parseInt(prev) : 1, url: this.getPageUrl(url, prev), disabled: !prev, onClick: this.buttonHit },
                { text: next, url: this.getPageUrl(url, next), disabled: !next, onClick: this.buttonHit },
            ],
            current: current,
            last: last,
        };
    };

    goToPage = (e) => {
        const { views } = this.props;
        const value = e.target.value;
        let last = 1;
        if (views['hydra:last']) {
            last = this.getNumberFromUri(views['hydra:last']);
        }

        const rgxAsStr = `^[0-9]+$`;
        const rgx = new RegExp(rgxAsStr);

        if (!value.match(rgx) && value !== '') {
            return;
        }

        if (parseInt(value) > last || parseInt(value) < 1) {
            return;
        }

        const btn = this.createGoToTextField(value);

        this.setState((prevState) => ({
            ...prevState,
            currentPage: parseInt(value),
            goToPageButton: btn,
        }));
    };

    createGoToTextField = (value) => {
        const { classes } = this.props;
        const goToPage = (
            <TextField
                onChange={this.goToPage}
                onKeyDown={this.handleKeyDown}
                variant={'filled'}
                classes={classes.paginatorTextField}
                value={value}
                inputProps={{
                    className: classes.paginatorInputStyle,
                }}
                InputProps={{
                    className: classes.paginatorLabelStyle,
                }}
            />
        );

        return goToPage;
    };

    goToLastPage = () => {
        const { views } = this.props;
        let last = 1;
        if (views['hydra:last']) {
            last = this.getNumberFromUri(views['hydra:last']);
        }
        const url = views['@id'].replace(/\?page=\d+/gi, '?page=').replace(/&page=\d+/gi, '&page=');
        return this.buttonHit(this.getPageUrl(url, last));
    };

    handleKeyDown = (e) => {
        if (e.key === 'Enter') {
            const url = this.props.views['@id'].replace(/\?page=\d+/gi, '?page=').replace(/&page=\d+/gi, '&page=');
            this.buttonHit(this.getPageUrl(url, this.state.currentPage));
        }
    };

    render() {
        const { views } = this.props;

        const { pages, current, last } = this.createPages();

        return (
            <Paginations
                goToLastPage={this.goToLastPage}
                currentPage={current}
                goToPage={this.state.goToPageButton}
                pages={pages}
                totalPage={last}
                color="info"
            />
        );
    }
}

export default withStyles(oplAppStyle)(Pager);
